/**
 * Cookie helpers for state that must be shared across the demo/admin subdomains
 * (e.g. demo.ai.sentioweb.com and admin.ai.sentioweb.com), where localStorage
 * cannot be used since it is scoped per-origin.
 */

function isIPAddress(host: string): boolean {
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || host.includes(':');
}

/** Returns the parent domain to scope the cookie to (e.g. ".ai.sentioweb.com"),
 * or undefined for localhost/IP hosts where a host-only cookie should be used. */
function getShareableCookieDomain(): string | undefined {
  const host = window.location.hostname;
  if (host === 'localhost' || isIPAddress(host)) return undefined;
  const labels = host.split('.');
  if (labels.length <= 2) return undefined;
  return `.${labels.slice(1).join('.')}`;
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name: string, value: string, days = 365): void {
  const domain = getShareableCookieDomain();
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  let cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  if (domain) cookie += `; domain=${domain}`;
  if (window.location.protocol === 'https:') cookie += '; Secure';
  document.cookie = cookie;
}
